import { Component, Prop, h, Host } from '@stencil/core';

const COMPONENT_NAME = 'sn-related-links-type-2';

/**
 * Related links section component for SignNow brand displaying a 4-column grid of plain text links with chevron icons.
 * Unlike type-1, this variant renders links without borders — just a chevron icon followed by bold blue link text.
 * The section heading is passed via the `title` prop (populated directly from backend data).
 * Designed for relinking content blocks on document/form pages.
 *
 * @product signnow
 * @source relinking1
 * @version 2.0.0
 * @category SignNow
 * @slot heading - <me-heading variant="2" tag=["h1", "h2", "h3", "h4", "h5", "h6", "div"]> - Section heading (inline editable)
 * @slot items - {required}, <li class="sn-related-links-type-2__list-item"> - Link list items
 * @example
 * <sn-related-links-type-2>
 *   <me-heading slot="heading" variant="2" tag="h2">Get more for Lease Agreement Form</me-heading>
 *   <li slot="items" class="sn-related-links-type-2__list-item" itemscope itemtype="https://schema.org/ListItem" itemprop="itemListElement">
 *     <a href="https://example.com/form-1" class="sn-related-links-type-2__link">
 *       <me-icon name="arrows--chevron-right" class="sn-related-links-type-2__link-icon"></me-icon>
 *       <span class="sn-related-links-type-2__link-text" itemprop="name">W 2c 2014 2018 form</span>
 *     </a>
 *     <meta itemprop="position" content="1" />
 *   </li>
 * </sn-related-links-type-2>
 */
@Component({
  tag: 'sn-related-links-type-2',
  styleUrl: 'index.scss',
  shadow: false,
})
export class SNRelatedLinksType2 {
  @Prop() colorMode: 'signnow' | 'inverted' = 'signnow';

  render() {
    return (
      <Host data-color-mode={this.colorMode}>
        <section class={COMPONENT_NAME}>
          <div class={`${COMPONENT_NAME}__container`}>
            <slot name="heading"></slot>
            <ul class={`${COMPONENT_NAME}__list`} itemScope itemType="https://schema.org/ItemList">
              <slot name="items"></slot>
            </ul>
          </div>
        </section>
      </Host>
    );
  }
}
